module.exports = __webpack_public_path__ + "img/personal-account--mobile.3154f39.jpg";